var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item"},[_c('a-form',{attrs:{"form":_vm.form,"layout":"vertical"}},[_c('a-form-item',{attrs:{"label":"Shipper"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'shipper',
          {
            rules: [
              {
                required: true,
                message: 'Please select shipper!',
              },
            ],
          },
        ]),expression:"[\n          'shipper',\n          {\n            rules: [\n              {\n                required: true,\n                message: 'Please select shipper!',\n              },\n            ],\n          },\n        ]"}]},_vm._l((_vm.providerLst),function(shipper){return _c('a-select-option',{key:shipper,attrs:{"value":shipper}},[_vm._v(_vm._s(shipper))])}),1)],1),_c('a-form-item',{attrs:{"label":"Tracking Code"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'tracking',
          {
            rules: [
              {
                required: true,
                message: 'Please input tracking!',
              },
            ],
          },
        ]),expression:"[\n          'tracking',\n          {\n            rules: [\n              {\n                required: true,\n                message: 'Please input tracking!',\n              },\n            ],\n          },\n        ]"}]})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }